import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="w-full py-12 px-4 border-t border-nerd-purple/10" style={{ background: '#0a0a1a' }}>
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="block mb-3 transition-opacity hover:opacity-80">
              <img src="/logo-text-only.png" alt="Nerd Coach Logo" className="h-20 md:h-24 w-auto object-contain" />
            </Link>
            <p className="text-nerd-gray text-xs leading-relaxed">Coaching mentale e fisico per chi vive tra schermi e mondi immaginari.</p>
          </div>
          <div>
            <h4 className="font-display text-xs uppercase tracking-wider text-nerd-white mb-4">Navigazione</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-nerd-gray text-sm hover:text-nerd-cyan transition-colors">Home</Link></li>
              <li><Link to="/metodo" className="text-nerd-gray text-sm hover:text-nerd-cyan transition-colors">Il Metodo</Link></li>
              <li><Link to="/nerd-power" className="text-nerd-gray text-sm hover:text-nerd-cyan transition-colors">Nerd Power</Link></li>
              <li><Link to="/about" className="text-nerd-gray text-sm hover:text-nerd-cyan transition-colors">Chi è Amedeo</Link></li>
              <li><Link to="/libro" className="text-nerd-gray text-sm hover:text-nerd-cyan transition-colors">Il Libro</Link></li>
              <li><Link to="/archetipi" className="text-nerd-gray text-sm hover:text-nerd-cyan transition-colors">Archetipi</Link></li>
              <li><Link to="/blog" className="text-nerd-gray text-sm hover:text-nerd-cyan transition-colors">Blog</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display text-xs uppercase tracking-wider text-nerd-white mb-4">Legale</h4>
            <ul className="space-y-2">
              {['Privacy', 'Termini'].map((l) => (
                <li key={l}>
                  <span className="text-nerd-gray text-sm cursor-default">{l}</span>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-display text-xs uppercase tracking-wider text-nerd-white mb-4">Social</h4>
            <ul className="space-y-2">
              {[
                { l: 'Instagram', href: 'https://instagram.com/nerdcoach.it' },
                { l: 'TikTok', href: 'https://tiktok.com/@nerdcoach.it' },
              ].map(({ l, href }) => (
                <li key={l}>
                  <a href={href} target="_blank" rel="noopener noreferrer me" className="text-nerd-gray hover:text-nerd-cyan text-sm transition-colors">{l}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="pt-6 border-t border-nerd-purple/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <span className="text-nerd-gray/50 text-xs">© {new Date().getFullYear()} Nerd Coach. Tutti i diritti riservati.</span>
          <span className="text-nerd-gray/50 text-xs font-display">nerdcoach.it</span>
        </div>
      </div>
    </footer>
  )
}
